import styled from 'styled-components';
import noDataImage from 'assets/images/nodata.png';
import noDataForFiltersImage from 'assets/images/noDataAvailableForFilters.png';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	background-color: ${colors.grey1};
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 100%;
`;

export const ImageContainer = styled.div`
	margin-top: 22px;
	background-image: url(${noDataImage});
	background-repeat: no-repeat;
	background-size: contain;
	min-height: 350px;
	min-width: 372px;

	${({ hasFilters }) =>
		hasFilters && `background-image: url(${noDataForFiltersImage});`};
`;

export const TextContainer = styled.div`
	max-width: 710px;
	margin-top: -38px;
`;

export const Title = styled.div`
	color: ${colors.grey8};
	margin-bottom: 16px;
	font-weight: 500;
	font-size: 33px;
	line-height: 41px;
	text-align: center;
	letter-spacing: 0.3px;
`;

export const Text = styled.div`
	color: ${colors.grey5};
	letter-spacing: 0;
	font-weight: normal;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
`;

export const Actions = styled.div`
	display: flex;
	padding: 32px;
	justify-content: center;
`;

export const ScrollContainer = styled.div`
	height: 100%;
	overflow: auto;
`;
